<template>
  <button class="custom-button" @click="handleClick">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: '',
    },
    action: {
      type: Function,
      default: null,
    },
  },
  methods: {
    handleClick() {
      if (this.action) {
        this.action()
      } else if (this.href) {
        this.$router.push(this.href)
      }
    },
  },
}
</script>

<style scoped>
.custom-button {
  background: none;
  border: none;
  color: var(--primary-color);
  font-family: Archivo, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5; /* Adjust for better spacing */
  text-decoration: underline solid;
  text-decoration-skip-ink: auto;
  text-underline-offset: 4px;
  text-decoration-thickness: 1px;
  text-underline-position: from-font;
  cursor: pointer;
  transition: color 0.3s ease, text-decoration-color 0.3s ease;
}

/* Hover Effect */
.custom-button:hover {
  color: #0d3a4a;
  text-decoration-color: #0d3a4a;
}
</style>
